import { TachographDriverStatus } from '@quadminds/shared/tracking-system';

export interface ITachographDrivingHoursSchema {
    dailyConsumed: string;
    dailyRemaining: string;
    weeklyAccumulated: string;
    biweeklyAccumulated: string;
    progressPercentage: number;
}

export interface ITachographCurrentStateSchema {
    status?: TachographDriverStatus;
    startTime?: string;
    duration?: string;
    speed?: number;
}

export interface ITachographPreviousStateSchema {
    status: TachographDriverStatus;
    startDay: string;
    startTime: string;
    endTime: string;
    endDay: string;
    duration: string;
}

export interface ITachographRemainingTimesSchema {
    timeLeftUntilDailyRest?: string;
    timeLeftUntilWeeklyRest?: string;
    remainingShiftDrivingTime?: string;
    timeUntilNextBreak?: string;
    nextBreakDuration?: string;
    remainingBiweeklyDrivingTime?: string;
}

export interface ITachographInformationSchema {
    driverId?: string;
    cardId?: string;
    driverName?: string;
    drivingHours?: ITachographDrivingHoursSchema;
    currentState?: ITachographCurrentStateSchema;
    previousStates?: ITachographPreviousStateSchema[];
    lastUpdateTime?: string;
    timeSinceLastUpdate?: number; // minutes
    remainingTimes?: ITachographRemainingTimesSchema;
    licensePlate?: string;
}
